import { find, prop, propEq } from 'ramda'
import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLinkedIn } from 'react-linkedin-login-oauth2'
import { useDispatch, useSelector } from 'react-redux'
import { confirm } from '@/components/dialog'
import { SwitchToggle } from '@/components/form'
import config from '@/config'

const { LINKEDIN_CLIENT_ID, APP_PATH } = config

const LinkedInButton = ({ enabled }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const session = useSelector(prop('session')) || {}
  const userId = session.session?.id
  const token = find(propEq('user_id', userId), session.user_social_media_tokens)
  const linkedInId = token?.id
  const redirectUri = `${window.location.origin}${APP_PATH}/linkedin`
  const [checked, setChecked] = useState(enabled)

  const linkedinCalled = useRef(false)
  const handleSuccess = code => {
    // Adding this check due to react in strict mode execute useEffect twice
    if (linkedinCalled.current) return
    linkedinCalled.current = true
    dispatch.profile.addLinkedIn({
      code,
      redirect_uri: redirectUri
    })

    setChecked(true)
  }

  const handleFailure = error => {
    setChecked(false)
  }

  const handleDisconnect = () => {
    if (linkedInId) {
      dispatch.profile.removeLinkedIn({
        id: linkedInId
      })
      setChecked(false)
      linkedinCalled.current = false
    }
  }

  const confirmDisconnect = () => {
    return confirm(
      t('r.profile.edit.disconnect_linkedin.title', 'Disconnect Account'),
      t(
        'r.profile.edit.disconnect_linkedin.text',
        'By disconnecting, your Trust Score will be affected. Are you sure you want to disconnect your account?'
      )
    ).then(async () => {
      await handleDisconnect()
    })
  }

  const { linkedInLogin } = useLinkedIn({
    scope: 'r_liteprofile r_emailaddress',
    clientId: LINKEDIN_CLIENT_ID,
    redirectUri, // for Next.js, you can use `${typeof window === 'object' && window.location.origin}/linkedin`
    onSuccess: code => {
      handleSuccess(code)
    },
    onError: error => {
      handleFailure(error)
    }
  })

  return (
    <SwitchToggle
      enabled={checked}
      name="linkedin"
      preventToggle={!!linkedInId}
      onChange={linkedInId ? confirmDisconnect : linkedInLogin}
    />
  )
}

export default LinkedInButton
